import * as React from "react";
import type { SVGProps } from "react";
const EventPlanning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_7547)">
      <path
        fill="currentColor"
        d="M8.5 0c.8297 0 1.5.6703 1.5 1.5V3h6V1.5c0-.8297.6703-1.5 1.5-1.5S19 .6703 19 1.5V3h2.25c1.2422 0 2.25 1.0078 2.25 2.25V7.5h-21V5.25C2.5 4.0078 3.5078 3 4.75 3H7V1.5C7 .6703 7.6703 0 8.5 0m-6 9h21v12.75c0 1.2422-1.0078 2.25-2.25 2.25H4.75c-1.2422 0-2.25-1.0078-2.25-2.25zm15.4219 5.2969c.4406-.4407.4406-1.1531 0-1.5891s-1.1531-.4406-1.5891 0l-4.4531 4.4531-2.2031-2.2031c-.4407-.4406-1.1532-.4406-1.5891 0-.436.4406-.4406 1.1531 0 1.5891l3 3c.4406.4406 1.1531.4406 1.5891 0z"
      />
    </g>
    <defs>
      <clipPath id="clip0_4362_7547">
        <path fill="transparent" d="M2.5 0h21v24h-21z" />
      </clipPath>
    </defs>
  </svg>
);
export default EventPlanning;
